// External partners (agencies) — see backend/auth/partners.py.
//
// A partner is an editor who sees what they created plus national content,
// creates national content only (no region / office), and never sees lead or
// enquiry personal data. The API answers 403 PARTNER_SCOPE outside their
// allowlist; these paths keep the UI to the screens that work for them.
import { useAuth } from '@/contexts/AuthContext';

export const isPartner = (user) => user?.auth_method === 'partner';

const PARTNER_PATHS = [
  '/dashboard',
  '/qrs',
  '/templates',
  '/editor',
  '/urls',
  '/pages',
  '/page-templates',
  '/brand',
  '/bio',
  '/campaigns',
  '/utm-builder',
  '/media',
  '/analytics',
  '/settings',
  '/help',
];

export function partnerMayOpen(pathname) {
  return PARTNER_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Region is mandatory on create forms, except for partners: their content is
// always national, so the backend clears any region they send.
export function useRegionRequired() {
  const { user } = useAuth();
  return !isPartner(user);
}
